// core
import endpointsCore, { serverUrl as serverUrlCore } from '../Core/Services/SuriApi'

export const serverUrl = serverUrlCore

export default endpointsCore
